import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@ui-framework/index';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';

function serviceJobNumber(original) {
  const editLink = `/servicejobs/edit/${original?.id}`;
  return (
    <Link to={editLink}>{original?.serviceJob?.serviceJobNumber || ''}</Link>
  );
}

function alertReason(original) {
  return (
    original?.communicationAlerts?.[0]?.alertReason ||
    original?.communicationAlerts?.[0]?.alertType ||
    ''
  );
}

function alertTime(original) {
  return original?.communicationAlerts?.[0]?.alertTime
    ? dayjs(original.communicationAlerts?.[0]?.alertTime).format(
        DATE_FORMAT.LONG_DATE,
      )
    : '';
}

function appointmentDate(original) {
  return original?.serviceJob?.appointmentDate
    ? dayjs(original.serviceJob.appointmentDate).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function customerAddressCity(original) {
  return original?.serviceJob?.customerAddressCity || '';
}

function customerAddressState(original) {
  return original?.serviceJob?.customerAddressState?.name || '';
}

function productType(original) {
  return original?.serviceJob?.productType?.productLineName || '';
}

function brand(original) {
  return original?.serviceJob?.brand?.brandName || '';
}

function customerComplaint(original) {
  return <ReadMoreText>{original?.serviceJob?.customerComplaint}</ReadMoreText>;
}

export {
  serviceJobNumber,
  alertReason,
  alertTime,
  appointmentDate,
  customerAddressCity,
  customerAddressState,
  productType,
  brand,
  customerComplaint,
};
